/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespRequestHoldToast_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespRequestHoldToastLoader_item$ref: FragmentReference;
export type PdpRespRequestHoldToastLoader_item = {|
  +$fragmentRefs: PdpRespRequestHoldToast_item$ref,
  +$refType: PdpRespRequestHoldToastLoader_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespRequestHoldToastLoader_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespRequestHoldToast_item",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'bb401348b8603ec3e293f1cf48632982';
module.exports = node;
